<script setup lang="ts">
import { useLocalStorage } from "@vueuse/core";
import { useHcpInbox } from "./useHcpInbox";
const { groups, total, count } = useHcpInbox();
const expanded = useLocalStorage("hcpUploadsExpanded", true);
</script>

<template>
  <nav
    v-if="groups.length"
    class="hcp-navigation"
    aria-label="HCP Uploads"
    data-test="hcp-navigation"
  >
    <div class="hcp-heading">
      <button
        type="button"
        class="hcp-expander"
        aria-label="HCP Uploads"
        :aria-expanded="expanded"
        @click="expanded = !expanded"
      >
        <span class="material-symbols-outlined hcp-icon" aria-hidden="true"
          >move_to_inbox</span
        >
        <span
          class="material-symbols-outlined hcp-chevron"
          aria-hidden="true"
          >{{ expanded ? "keyboard_arrow_down" : "chevron_right" }}</span
        >
      </button>
      <RouterLink :to="{ name: 'HcpInbox' }" class="hcp-heading-link">
        <span class="hcp-label">HCP Uploads</span>
        <span v-if="total" class="hcp-badge" data-test="hcp-total">{{
          total
        }}</span>
      </RouterLink>
    </div>
    <div v-show="expanded" class="hcp-groups">
      <RouterLink
        v-for="group in groups"
        :key="group.id"
        :to="{
          name: 'HcpInbox',
          params: { hcpWorkspaceId: group.id },
        }"
        class="hcp-group"
        :data-hcp-workspace="group.id"
      >
        <span class="hcp-name"
          >{{ group.name
          }}<small v-if="group.sourceDeleted">{{
            $t("hcpInbox.sourceDeleted")
          }}</small></span
        >
        <span v-if="count(group)" class="hcp-badge">{{ count(group) }}</span>
      </RouterLink>
    </div>
  </nav>
</template>

<style scoped>
.hcp-navigation {
  margin: 0.1em 0 1em;
  color: var(--classic-text, var(--tw-color-label, inherit));
  font-size: 0.9em;
}
.hcp-heading {
  display: flex;
  align-items: center;
  padding: 0 1.2em;
  min-height: 3.1em;
  font-weight: 500;
}
.hcp-heading-link,
.hcp-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  color: inherit;
  text-decoration: none;
}
.hcp-heading-link {
  flex: 1;
  min-width: 0;
  align-self: stretch;
}
.hcp-expander {
  position: relative;
  flex-shrink: 0;
  font: inherit;
  font-size: 1.4em;
  width: 1em;
  height: 1em;
  margin-right: 0.3em;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.hcp-expander .material-symbols-outlined {
  display: block;
  font-size: inherit;
}
.hcp-chevron {
  position: absolute;
  inset: 0;
  visibility: hidden;
}
.hcp-heading:hover .hcp-icon,
.hcp-heading:focus-within .hcp-icon {
  visibility: hidden;
}
.hcp-heading:hover .hcp-chevron,
.hcp-heading:focus-within .hcp-chevron {
  visibility: visible;
}
.hcp-group {
  padding: 0.6rem 0.75rem 0.6rem 45px;
}
.hcp-heading:hover,
.hcp-group:hover,
.hcp-group.router-link-exact-active {
  background: var(--classic-surface-hover, rgb(128 128 128 / 0.12));
}
.hcp-name {
  min-width: 0;
  overflow-wrap: anywhere;
}
small {
  display: block;
  opacity: 0.65;
  font-size: 0.8em;
  margin-top: 0.15rem;
}
.hcp-badge {
  flex-shrink: 0;
  background: #147c80;
  color: white;
  border-radius: 1rem;
  padding: 0.1rem 0.45rem;
  font-size: 12px;
  font-weight: 600;
}
</style>
